import { isLocationCityId, type LocationCityId } from '@/collections/Locations/cityOptions'
import type { City, Location } from '@/payload-types'

export function resolveCitySlug(city: number | City | LocationCityId | null | undefined): LocationCityId | null {
  if (!city) return null

  if (typeof city === 'string' && isLocationCityId(city)) {
    return city
  }

  if (typeof city === 'object' && city.slug && isLocationCityId(city.slug)) {
    return city.slug
  }

  return null
}

export function resolveLocationCitySlug(
  location: number | Location | null | undefined,
): LocationCityId | null {
  if (!location || typeof location === 'number') return null

  return resolveCitySlug(location.city)
}
